// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__S1FsF","author":"Table_author__3DhbU","authorImage":"Table_authorImage__GSB0C","unreadRow":"Table_unreadRow__3EA2Z"};